import { render } from "./AccountsOptions.vue?vue&type=template&id=2db242d7"
import script from "./AccountsOptions.vue?vue&type=script&lang=js"
export * from "./AccountsOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__